module.exports = __webpack_public_path__ + "015bed1f.png";